"use client";

import { PageCenter } from "@/components/ui/page-center";
import { OutboundLink } from "@/features/outbound-link/outbound-link";
import { withBasePath } from "@/lib/base-path";
import { BiEvent } from "@/lib/bi/bi.enum";
import { cn } from "@/lib/utils";

import { usePrimeDayCountdown } from "../../hooks/use-prime-day-countdown";
import { CountdownDigits } from "../countdown-digits";

type Props = {
  className?: string;
  primeDayUrl: string;
};

export function BannerBottom({ className, primeDayUrl }: Props) {
  const { hours, minutes, seconds } = usePrimeDayCountdown();

  return (
    <OutboundLink
      url={primeDayUrl}
      storeName="Amazon"
      bi={{
        eventType: BiEvent.BannerOutbound,
        provider: "amazon",
        location: "prime-day-banner",
      }}
      target="_blank"
      rel="noopener noreferrer"
      className={cn(
        "relative h-14 overflow-hidden",
        "hidden lg:flex items-center justify-center",
        "bg-[#e6f4ff] border-t-2 border-[#fda337] shadow-[0px_-4px_8px_0px_rgba(199,199,199,0.25)]",
        "text-[#216eb4] sub1",
        "lg:sticky bottom-0",
        className,
      )}
    >
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img
        src={withBasePath("/prime-day/bags.svg")}
        aria-hidden="true"
        alt=""
        width={50}
        height={56}
        className="absolute bottom-0 left-[max(0px,calc(50%-512px))]"
      />
      <PageCenter className="flex gap-x-2 items-baseline justify-between">
        <span className="flex gap-x-2 ps-14">
          <span>Prime Day sale</span>
          <span className="inline-flex items-center gap-0.5 text-[20px] leading-7">
            <CountdownDigits
              value={hours}
              label="Hrs"
            />
            <CountdownDigits
              value={minutes}
              label="Min"
            />
            <CountdownDigits
              value={seconds}
              label="Sec"
            />
          </span>
        </span>
        <span className="rounded-[8px] bg-[#4aa409] text-grayscale-white px-4 py-[6px] self-start ms-2">
          Check Prime day deals
        </span>
      </PageCenter>
    </OutboundLink>
  );
}
